<template>
    <nav class="flex flex-wrap gap-3" aria-label="Tabs">
        <slot />
    </nav>
</template>

<script>
export default {
    name: 'ZenTabList',
}
</script>
